<template>
    <modal
        v-if="isActive"
        :show="showModal"
        :showContent="showContent"
        :pageTitle="title"
        :acl="acl"
        :url="url"
        @close="closeModal"
        position="left"
        class="regulation">
        <template v-slot:content>
            <div class="panel-control d-flex flex-column flex-fill">
                <div class="panel-control-content d-flex flex-column flex-fill">
                    <div class="row">
                        <div class="col">
                            <span class="title"> {{ title }}</span>
                            <hr/>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="d-flex flex-column flex-fill">
                                <div class="panel">
                                    <tree-grouped-links
                                        :nodes="items"
                                        :emptyMessage="emptyMessage"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
    import ButtonControlMixin from '@/components/maps/mixins/ButtonControlMixin';

    export default {
        mixins: [
            ButtonControlMixin,
        ],
        components:{
            Modal: () => import(/* webpackChunkName: "modal-data" */ '@/app/shared/components/modals/ModalData'),
            TreeGroupedLinks: () => import(/* webpackChunkName: "tree-grouped-links" */ '@/app/shared/components/grouped_links/TreeGroupedLinks'),
        },
        data() {
            return {
                idPanel: 'regulations',
                className: 'ol-regulation',
                showContent: true,
                items: [],
            }
        },
        created () {
            this.$eventBus.listen(this.moduleCode, 'map.new-feature-initialize', this.closeModal);
            this.$eventBus.listen(this.moduleCode, 'map.start-street-view-panorama', this.closeModal);
        },
        beforeDestroy() {
            this.$eventBus.remove(this.moduleCode, 'map.new-feature-initialize', this.closeModal);
            this.$eventBus.remove(this.moduleCode, 'map.start-street-view-panorama', this.closeModal);
        },
        computed: {
            showModal() {
                return this.isActive && this.isPanelVisible;
            },
            emptyMessage() {
                return this.loaded ? `${this.idPanel}.no-data` : `${this.idPanel}.loading`;
            }
        },
        methods: {
            initialize: function() {
                if(this.loaded){
                    return;
                }
                this.loadData();
            },
            closeModal: function() {
                this.closePanel(this.idPanel);
            },
            addButtonMap: function(_map){
                let btn = _map.createBtnImg(
                    this.assetsPathTheme('/map/regulation.svg'),
                    _map.getControlClassName(this.orderClassName),
                    this.title,
                    [
                        {
                            type: 'click',
                            event: (evt) =>
                            {
                                this.openPanel(this.idPanel);
                                evt.stopPropagation();
                            }
                        }
                    ],
                    this.lblBtn
                );
                _map.addControl(this.posBtnMap, btn);
                this.$eventBus.listen(this.moduleCode, 'map.new-feature-initialize', (evt)=>{
                    let el = $(btn.element); if(el) el.hide()
                });
                this.$eventBus.listen(this.moduleCode, 'map.new-feature-finished', (evt)=>{
                    let el = $(btn.element); if(el) el.show()
                });
                return btn;
            },
            reset() {
            },
            async loadData() {
                let url = this.url.getData;
                if (url) {
                    await this.$http.get(this.formatUrl(url, {applicationCode: this.applicationCode}))
                    .then(res => {
                        this.items = res.data.data;
                        this.loaded = true;
                    })
                    .catch(error => {
                        this.showHttpError(error);
                    })
                }
                return Promise.resolve(false);
            },
        },

        watch: {
            showModal (value) {
                if(value){
                    this.initialize();
                }
            },
        },
    }
</script>

